import * as actionTypes from 'redux/actions'

const initialState = {}

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ANALYTICS_DATA: {
      return {
        ...state,
        ...action.payload
      }
    }
    case actionTypes.SET_MAP_BOUNDS: {
      return {
        ...state,
        mapBounds: action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default analyticsReducer
